import * as React from 'react';
import { withStyles, createStyles, Theme } from '@material-ui/core/styles';
import { withRouter, RouteComponentProps } from 'react-router';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ArrowBack from '@material-ui/icons/ArrowBack';


const jss = (theme: Theme) => createStyles({
    typography: {
        width: '100%',
        wordBreak: 'break-word',
    },
    backBtn: {
        flex: '0 0 auto',
        width: '3rem',
        height: '3rem',
        float: 'left'
    },
});

interface Props extends RouteComponentProps {
    title: string;
    back?: string;
    classes: { [className: string]: string; };
}

class PageTitle extends React.Component<Props, {}> {

    handleBack = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        if (this.props.back) {
            this.props.history.push(this.props.back);
        }
    };

  	render() {
        const { classes, back, title } = this.props;

        return (
            <div style={{ display: 'flex', width: '100%' }}>
                <Typography variant="h3" align="center" gutterBottom className={classes.typography}>
                    {back && (
                        <Button variant="fab" color="primary" className={classes.backBtn} onClick={this.handleBack} href={back}>
                            <ArrowBack />
                        </Button>)
                    }
                    {title}
                </Typography>
            </div>
        );
	}
}

export default withRouter(withStyles(jss)(PageTitle));



// WEBPACK FOOTER //
// ./src/components/Common/PageTitle.tsx